<template>
	<section>
		<loader :dialog="loading"></loader>
		<floating-alert
			:message="alertMessage"
			:show="alertShow"
			:type="alertType"
		></floating-alert>

		<v-card elevation="2" rounded="xl" class="cal-card">
			<!-- Calendar toolbar -->
			<div class="cal-toolbar">
				<div class="cal-toolbar-left">
					<v-btn outlined small rounded color="grey darken-2" @click="setToday" class="mr-3">
						Aujourd'hui
					</v-btn>
					<v-btn icon small color="grey darken-2" @click="prev">
						<v-icon small>mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn icon small color="grey darken-2" @click="next">
						<v-icon small>mdi-chevron-right</v-icon>
					</v-btn>
					<span class="cal-title" v-if="$refs.calendar">
						{{ $refs.calendar.title }}
					</span>
				</div>

				<v-menu bottom right>
					<template v-slot:activator="{ on, attrs }">
						<v-btn outlined small rounded color="grey darken-2" v-bind="attrs" v-on="on">
							<span>{{ typeToLabel[type] }}</span>
							<v-icon right small>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list dense rounded>
						<v-list-item @click="type = 'day'">
							<v-list-item-title>Jour</v-list-item-title>
						</v-list-item>
						<v-list-item @click="type = 'week'">
							<v-list-item-title>Semaine</v-list-item-title>
						</v-list-item>
						<v-list-item @click="type = 'month'">
							<v-list-item-title>Mois</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</div>

			<v-divider></v-divider>

			<!-- Calendar -->
			<v-calendar
				ref="calendar"
				v-model="focus"
				color="#c62828"
				event-more-text="VOIR PLUS"
				locale="fr-FR"
				:events="foods"
				:event-color="getEventColor"
				:type="type"
				@click:event="showEvent"
				@click:more="viewDay"
				@click:date="viewDay"
				style="min-height: 480px;"
			></v-calendar>

			<!-- Event popup -->
			<v-menu
				v-model="selectedOpen"
				:close-on-content-click="false"
				:activator="selectedElement"
				offset-x
			>
				<v-card elevation="4" rounded="xl" min-width="340px" class="pa-1">
					<div
						class="cal-event-header"
						:style="{ background: selectedEvent.color || '#c62828' }"
					>
						<div class="cal-event-title">
							<p class="cal-event-name" v-html="selectedEvent.name + ' - ' + selectedEvent.period"></p>
						</div>
						<v-btn icon x-small color="white" @click="deleteItem(selectedEvent)">
							<v-icon size="16">mdi-delete</v-icon>
						</v-btn>
					</div>
					<v-card-text class="pt-3 pb-2" v-if="selectedEvent.food">
						<p class="cal-event-food-name" v-html="selectedEvent.food.label"></p>
						<p
							class="cal-event-desc"
							v-html="selectedEvent.food.description"
						></p>
					</v-card-text>
					<v-card-actions class="pa-3 pt-0">
						<v-btn text small color="error" rounded @click="selectedOpen = false">
							Fermer
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-menu>
		</v-card>

		<!-- Delete confirm dialog -->
		<v-dialog v-model="dialogDelete" max-width="440px">
			<v-card rounded="xl" class="pa-2">
				<div class="del-header">
					<div class="del-icon">
						<v-icon size="18" color="white">mdi-alert</v-icon>
					</div>
					<p class="del-title">Supprimer cette attribution ?</p>
				</div>
				<v-card-actions class="pa-4 pt-2">
					<v-btn text color="grey" rounded @click="closeDelete">Annuler</v-btn>
					<v-spacer></v-spacer>
					<v-btn depressed rounded class="del-confirm-btn" @click="deleteItemConfirm">
						Supprimer
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import Loader from "@/components/Loader.vue";
import service from "@/services";
import calendarData from "@/helpers/Calendar-data";
import FloatingAlert from "@/components/FloatingAlert.vue";
export default {
	components: { Loader, FloatingAlert },
	data: () => ({
		dialogDelete: false,
		loading: false,
		alertMessage: "",
		alertShow: false,
		alertType: "",
		foods: [],
		focus: "",
		type: "month",
		typeToLabel: { month: "Mois", week: "Semaines", day: "Jours" },
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		editedIndex: -1,
	}),
	created() {
		this.initialize();
	},
	methods: {
		initialize() {
			this.loading = true;
			service.getFoodsAttributions().then((r) => {
				this.foods = calendarData.transformMealsData(r.data);
				this.loading = false;
			}).catch((e) => { console.log(e); this.loading = false; });
		},
		viewDay({ date }) { this.focus = date; this.type = "day"; },
		getEventColor(event) { return event.color; },
		setToday() { this.focus = ""; },
		prev() { this.$refs.calendar.prev(); },
		next() { this.$refs.calendar.next(); },
		showEvent({ nativeEvent, event }) {
			const open = () => {
				this.selectedEvent = event;
				this.selectedElement = nativeEvent.target;
				requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
			};
			if (this.selectedOpen) {
				this.selectedOpen = false;
				requestAnimationFrame(() => requestAnimationFrame(() => open()));
			} else {
				open();
			}
			nativeEvent.stopPropagation();
		},
		deleteItem(item) {
			this.editedIndex = this.foods.indexOf(item);
			this.dialogDelete = true;
		},
		deleteItemConfirm() {
			this.alertShow = false;
			this.loading = true;
			service.removeAttribution(this.selectedEvent.id).then((r) => {
				this.foods.splice(this.editedIndex, 1);
				this.closeDelete();
				this.loading = false;
				this.alertMessage = r.message;
				this.alertShow = true;
				this.alertType = "green";
			}).catch(() => {
				this.loading = false;
				this.alertMessage = "Impossible de supprimer l'attribution";
				this.alertShow = true;
				this.alertType = "red";
			});
		},
		closeDelete() {
			this.dialogDelete = false;
			this.$nextTick(() => { this.editedIndex = -1; });
		},
	},
};
</script>

<style scoped>
.cal-card {
	font-family: Montserrat, sans-serif;
	overflow: hidden;
}
.cal-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 14px 16px;
	flex-wrap: wrap;
	gap: 10px;
}
.cal-toolbar-left {
	display: flex;
	align-items: center;
	gap: 6px;
}
.cal-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin-left: 8px;
}
.cal-event-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 14px;
	border-radius: 11px 11px 0 0;
}
.cal-event-name {
	font-size: 0.82rem;
	font-weight: 700;
	color: white;
	margin: 0;
}
.cal-event-food-name {
	font-size: 0.85rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 4px;
}
.cal-event-desc {
	font-size: 0.75rem;
	color: #6b7280;
	margin: 0;
}
.del-header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px 20px 12px;
}
.del-icon {
	width: 34px;
	height: 34px;
	border-radius: 8px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
}
.del-title {
	font-size: 0.9rem;
	font-weight: 700;
	color: #111827;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.del-confirm-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
}
</style>
